import { inject, Injectable } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Result } from '@hereisyourgitanton/core';
import { Observable } from 'rxjs';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';
import { OfferAdminResponseDto } from '../schemas/offer-admin-response.dto';

@Injectable({ providedIn: 'root' })
export class OfferAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(TRADGINE_DATA_API_BASE_URL)}/offerAdmin`;

    getAll(lotId: number): Observable<Result<OfferAdminResponseDto[], Error>> {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<OfferAdminResponseDto[]>()
            .withHttpParams(new HttpParams().set('lotId', lotId))
            .build()
            .send();
    }

    getById(id: number): Observable<Result<OfferAdminResponseDto, Error>> {
        return this.builder
            .url(`${this.controllerUrl}/getById`)
            .get()
            .json<OfferAdminResponseDto>()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }
}
